import { isNil, isNaN } from 'lodash';
import numeral from 'numeral';

export const CurrencyFormats = {
  currencyWithNoDecimalPlaces: '$0,0',
  currencyWithTwoDecimalPlaces: '$0,0.00',
};

export const formatInt = (value: number | null | undefined): string => {
  if (isNil(value)) {
    return '';
  }

  return numeral(value).format('0,0');
};

export const formatMaxDecimalFloat = (value: number | null | undefined, maxDecimalPlaces: number = 2): string => {
  if (isNil(value)) {
    return '0';
  }

  const fractionalPart = '0'.repeat(maxDecimalPlaces);
  const format = `0,0.[${fractionalPart}]`;

  return numeral(value).format(format);
};

export const formatFloat = (value: number | null | undefined, decimalPlaces: number = 2): string | null | undefined => {
  if (isNil(value)) {
    return value;
  }

  const fractionalPart = '0'.repeat(decimalPlaces);
  const format = `0,0.${fractionalPart}`;

  return numeral(value).format(format);
};

export const formatXmlFloat = (
  value: number | null | undefined,
  decimalPlaces: number = 2
): string | null | undefined => {
  if (isNil(value)) {
    return value;
  }

  const fractionalPart = '0'.repeat(decimalPlaces);
  const format = `0.${fractionalPart}`;

  return numeral(value).format(format);
};

export const formatPercentageFloat = (
  value: number | null | undefined,
  maxDecimal: number = 4
): number | null | undefined => {
  if (isNil(value)) {
    return value;
  }

  return parseFloat((value * 100).toFixed(maxDecimal));
};

export const formatPercentageString = (
  value: number | null | undefined,
  maxDecimal: number = 4
): string | null | undefined => {
  // eslint-disable-next-line no-restricted-syntax
  if (value == null) {
    return value;
  }
  if (isNaN(value)) {
    return '';
  }
  return `${+value.toFixed(maxDecimal)}%`;
};

export const formatCurrencyInt = (value: number | null | undefined): string | null | undefined => {
  const { currencyWithNoDecimalPlaces } = CurrencyFormats;

  if (isNil(value) || !isFinite(value)) {
    return '';
  }

  return numeral(Math.round(value)).format(currencyWithNoDecimalPlaces);
};

export const formatCurrencyFloat = (value: number | null | undefined): string => {
  const { currencyWithTwoDecimalPlaces } = CurrencyFormats;

  if (isNil(value)) {
    return '';
  }

  return numeral(Number(value).toFixed(2)).format(currencyWithTwoDecimalPlaces);
};

export const formatToNumericString = (value: string | number | null | undefined = ''): string | null | undefined => {
  if (isNil(value)) {
    return value;
  }

  return value.toString().replace(/\D/g, '');
};

export const toPercentageString = (value: number | null | undefined, decimalPlaces: number = 2): string => {
  const fullValue = (value as number) * 100;
  if (isNaN(fullValue)) {
    return '';
  }
  return isNil(value) ? '' : `${fullValue.toFixed(decimalPlaces)}%`;
};
